/* Like (GH #2796; spec §3.1): a ghost button in the secondary text colour, under the comment's body */
.button,
.own {
  display: inline-flex;
  align-items: center;
  gap: var(--tuna-spacing-0_5);
  min-width: 32px;
  min-height: 32px;
  color: var(--tuna-palette-text-secondary);
  font-size: var(--tuna-typography-caption-fontSize);
}

/* 44 px on a coarse pointer (spec §6, WCAG 2.5.8) */
@media (pointer: coarse) {
  .button {
    min-width: 44px;
    min-height: 44px;
  }
}

/* Pressed: the icon and count in the primary colour */
.pressed {
  color: var(--tuna-palette-primary-main);
}

.icon {
  width: 18px;
  height: 18px;
}

.count {
  line-height: 1;
}

.own {
  padding: 0 var(--tuna-spacing-1);
}

.visuallyHidden {
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0 0 0 0);
  white-space: nowrap;
  border: 0;
}
